import { render, staticRenderFns } from "./ActiveSlider.vue?vue&type=template&id=6cbee458&scoped=true"
import script from "./ActiveSlider.vue?vue&type=script&lang=js"
export * from "./ActiveSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbee458",
  null
  
)

export default component.exports